import { id } from './id';
import { en } from './en';
import type { Language } from '../types';

export const translations: Record<Language, any> = {
    id,
    en,
};
